import React from "react";
import ProfileView from "../components/ProfileView";

export default function Profile() {
  return (
    <ProfileView />
  );
}
